var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _require = require('./identity-struct'),
    generateIdentityChain = _require.generateIdentityChain,
    generateIdentityKeyReplacementEntry = _require.generateIdentityKeyReplacementEntry,
    _require2 = require('./key-helpers'),
    isValidIdentityKey = _require2.isValidIdentityKey,
    isValidSecretIdentityKey = _require2.isValidSecretIdentityKey,
    getPublicIdentityKey = _require2.getPublicIdentityKey,
    generateRandomIdentityKeyPair = _require2.generateRandomIdentityKeyPair;

var _require3 = require('./identity-information-retriever'),
    getActiveKeysAtHeight = _require3.getActiveKeysAtHeight;

function createIdentity(_x, _x2, _x3, _x4) {
  return _createIdentity.apply(this, arguments);
}

function _createIdentity() {
  _createIdentity = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(cli, name, keys, ecAddress) {
    var identityKeys, publicKeys, idChain, added;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            identityKeys = getIdentityKeys(keys);
            publicKeys = identityKeys.map(function (idKey) {
              return idKey.public;
            });
            idChain = generateIdentityChain(name, publicKeys);
            _context.next = 5;
            return cli.add(idChain, ecAddress);

          case 5:
            added = _context.sent;
            return _context.abrupt("return", Object.assign(added, {
              identityKeys: identityKeys
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createIdentity.apply(this, arguments);
}

function getIdentityKeys(identityKeys) {
  var result = [];

  if (typeof identityKeys === 'number') {
    for (var i = 0; i < identityKeys; ++i) {
      result.push(generateRandomIdentityKeyPair());
    }
  } else if (Array.isArray(identityKeys)) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = identityKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var idKey = _step.value;

        if (!isValidIdentityKey(idKey)) {
          throw new Error("".concat(idKey, " is not a valid identity key."));
        }

        result.push({
          public: getPublicIdentityKey(idKey)
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else {
    throw new Error("Invalid `keys` argument type: ".concat(typeof identityKeys));
  }

  return result;
}

function replaceIdentityKey(_x5, _x6, _x7, _x8) {
  return _replaceIdentityKey.apply(this, arguments);
}

function _replaceIdentityKey() {
  _replaceIdentityKey = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(cli, identityChainId, keys, ecAddress) {
    var oldPublicIdKey, newPublicIdKey, signingIdKey, activeKeys, entry;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (isValidSecretIdentityKey(keys.signingSecretIdKey)) {
              _context2.next = 2;
              break;
            }

            throw new Error('signingSecretIdKey must be a valid secret identity key');

          case 2:
            oldPublicIdKey = getPublicIdentityKey(keys.oldIdKey);
            newPublicIdKey = getPublicIdentityKey(keys.newIdKey);
            signingIdKey = {
              public: getPublicIdentityKey(keys.signingSecretIdKey),
              secret: keys.signingSecretIdKey
            };
            _context2.next = 7;
            return getActiveKeysAtHeight(cli, identityChainId);

          case 7:
            activeKeys = _context2.sent;

            if (activeKeys.includes(oldPublicIdKey)) {
              _context2.next = 10;
              break;
            }

            throw new Error("Old identity key ".concat(oldPublicIdKey, " is not part of the active keys: [").concat(activeKeys, "]."));

          case 10:
            if (activeKeys.includes(signingIdKey.public)) {
              _context2.next = 12;
              break;
            }

            throw new Error("Signer identity key ".concat(signingIdKey.public, " is not part of the active keys: [").concat(activeKeys, "]."));

          case 12:
            if (!(activeKeys.indexOf(oldPublicIdKey) < activeKeys.indexOf(signingIdKey.public))) {
              _context2.next = 14;
              break;
            }

            throw new Error("Priority of the signing key ".concat(signingIdKey.public, " is not sufficient to replace the key ").concat(oldPublicIdKey));

          case 14:
            entry = generateIdentityKeyReplacementEntry(identityChainId, oldPublicIdKey, newPublicIdKey, signingIdKey);
            return _context2.abrupt("return", cli.add(entry, ecAddress));

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _replaceIdentityKey.apply(this, arguments);
}

module.exports = {
  createIdentity: createIdentity,
  replaceIdentityKey: replaceIdentityKey
};